export const FONTS = {
  PROXIMA_NOVA: `proxima-nova, sans-serif`,
}
